import styled from '@emotion/styled';
import { Box, Button, Card, CardActionArea, CircularProgress, Divider, Typography } from '@mui/material'
import React from 'react'
import { VirtuosoGrid } from 'react-virtuoso'
import { FilesDispatch } from './model';
import IndexState from '../../State/IndexState';
import AutoSizer from 'react-virtualized-auto-sizer';
import '../../../../../../Util/ext'
import FileUI from '../../../File/UI/Mobile/File';
import FilterUI from '../../../Filter/UI/Browser/Filter';
import BookmarkUI from '../../../Bookmark/UI/Mobile/Bookmark';
import SeenUI from '../../../LastSeen/UI/Mobile/Seen';
import AllMoshaveranUI from '../../../AllMoshaveran/UI/Mobile/AllMoshaveran';

const ItemContainer = styled.div`
  padding: 0.5rem;
  width: 100%;
  display: flex;
  flex: none;
  align-content: stretch;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    width: 100%;
  }

  @media (max-width: 300px) {
    width: 100%;
  }
`

const ItemWrapper = styled.div`
  flex: 1;
  text-align: center;
  font-size: 80%;
  padding: 1rem 1rem;
  border: 1px solid var(gray);
  white-space: nowrap;
`

const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

class Index extends React.PureComponent<{}>{

    componentDidMount(): void {
        let dispatcher: FilesDispatch = (this.props as any).dispatcher
        let state: IndexState = (this.props as any).state
        dispatcher.fetchFilesList(1, state.filter)
    }

    render() {

        let dispatcher: FilesDispatch = (this.props as any).dispatcher
        let state: IndexState = (this.props as any).state

        let html: JSX.Element

        if (state.loading && state.data.length === 0) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <CircularProgress />
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }}>
                    در حال دریافت اطلاعات
                </Typography>
            </Box>
        } else if (state.data && state.data.length === 0) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }} color='error'>
                    اطلاعات یافت نشد
                </Typography>
                <Button variant="contained" color='error' size='small' onClick={() => {
                    dispatcher.fetchFilesList(1, state.filter)
                }}>تلاش مجدد</Button>
            </Box>
        } else if (state.error) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }} color='error'>
                    اطلاعات دریافت نشد
                </Typography>
                <Button variant="contained" color='error' size='small' onClick={() => {
                    dispatcher.fetchFilesList(1, state.filter)
                }}>تلاش مجدد</Button>
            </Box>
        } else {

            html = <Box sx={{ pr: 1, pl: 1, pt: 2, pb: 2, height: '100%' }}>
                <VirtuosoGrid endReached={() => {
                    if (!state.loading)
                        dispatcher.fetchFilesList((Math.ceil(state.data.length / 20)) + 1, state.filter)
                }} /*className='none-scrollbar'*/ components={{
                    Item: ItemContainer,
                    List: ListContainer as any,
                    Footer: () => {
                        return (
                            <div
                                style={{
                                    padding: '2rem',
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <CircularProgress />
                            </div>
                        )
                    },
                    ScrollSeekPlaceholder: ({ height, width, index }) => (
                        <ItemContainer>
                            <ItemWrapper>{'--'}</ItemWrapper>
                        </ItemContainer>
                    ),
                }} totalCount={state.data?.length} itemContent={(index, data, context) => {
                    let value = state.data[index]

                    return <Card key={index} variant="elevation" sx={{ width: '100%', height: '400px', borderRadius: '12px', borderColor: 'transparent' }} >
                        <CardActionArea sx={{ width: '100%', height: '100%', flexDirection: 'column' }} onClick={() => {
                            dispatcher.onItemClicked(value)
                        }}>

                            <AutoSizer disableHeight style={{ width: '100%' }}>
                                {({ width }: any) => {
                                    return (
                                        <Box sx={{
                                            height: '300px',
                                            width: width
                                        }} >
                                            <Box
                                                component="img"
                                                sx={{
                                                    height: '300px',
                                                    width: width,
                                                    objectFit: 'cover'
                                                }}
                                                alt='vilage'
                                                src={value.picPath + value.pics[0]}
                                                crossOrigin='anonymous'
                                            />

                                            <Box sx={{
                                                position: 'absolute',
                                                top: 0,
                                                right: 0, m: 1
                                            }}><Card variant="outlined" sx={{ pr: 1, pl: 1, borderRadius: '24px', borderColor: 'transparent' }} >

                                                    <Typography variant="caption" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary' textAlign='center'>
                                                        {new Date(value.updateAt).ago()}
                                                    </Typography>
                                                </Card></Box>
                                        </Box>
                                    )
                                }
                                }
                            </AutoSizer>
                            <Box sx={{ width: '100%', flexDirection: 'row', mt: 2 }} display='flex'>

                                <Box sx={{ flexGrow: 0.25, flexDirection: 'column', pr: 1, pl: 1 }} display='flex' justifyContent="center" alignItems="center">
                                    <Typography variant="subtitle2" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary'>
                                        نوع
                                    </Typography>
                                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />
                                    <Typography variant="subtitle2" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary'>
                                        {(value.fileType as any).title}
                                    </Typography>
                                </Box>
                                {
                                    value.props.map((val, index, arr) => {
                                        return (
                                            <Box key={val.value + val.title + index} sx={{ flexGrow: 0.25, flexDirection: 'column', pr: 1, pl: 1 }} display='flex' justifyContent="center" alignItems="center">
                                                <Typography variant="subtitle2" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary'>
                                                    {val.title}
                                                </Typography>
                                                <Divider orientation="horizontal" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />
                                                <Typography variant="subtitle2" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary'>
                                                    {val.valueType === 'price' ? val.value.toWordPrice() : `${val.value}`}
                                                </Typography>
                                            </Box>
                                        )
                                    })
                                }

                            </Box>
                        </CardActionArea>

                    </Card>

                }} />


                <FileUI />
                <FilterUI />
                <BookmarkUI />
                <SeenUI />
                <AllMoshaveranUI />
            </Box>
        }

        return html
    }
}

export default Index